import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/ua', {
    uaData: 'data'
  })), {}, {
    uaStr: function uaStr() {
      var _this$uaData = this.uaData,
          browser = _this$uaData.browser,
          engine = _this$uaData.engine,
          os = _this$uaData.os,
          device = _this$uaData.device,
          cpu = _this$uaData.cpu;
      return JSON.stringify({
        browser: browser,
        engine: engine,
        os: os,
        device: device,
        cpu: cpu
      }, null, 2);
    }
  })
};